var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sljr-render"},[_c('Breadcrumb'),_c('el-container',[_c('el-aside',{attrs:{"width":"228px"}},[_c('SideMenu',{attrs:{"items":_vm.items}})],1),_c('el-main',{staticClass:"conten-box"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }